import { useEffect } from "react";

export const useScrollLock = (isLocked) => {
  useEffect(() => {
    const root = document.documentElement;

    if (isLocked) {
      root.style.overflow = "hidden";
    } else {
      root.style.overflow = "auto";
    }

    return () => {
      root.style.overflow = "auto";
    };
  }, [isLocked]);
};

export default useScrollLock;
